import RfiList from './RfiList.page';

export default RfiList;
